import { render, staticRenderFns } from "./OnboardingSteps.vue?vue&type=template&id=01546dec&scoped=true&"
import script from "./OnboardingSteps.vue?vue&type=script&lang=js&"
export * from "./OnboardingSteps.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingSteps.vue?vue&type=style&index=0&id=01546dec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01546dec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VDivider,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep})
